<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="h2">List of Illustrations</a></h2><a id="h2">
<p class="noindent"><span class="bold">Maps</span></p>
</a><p class="noindent"><a id="h2"></a><a href="#/06_introduction1#map1">1. The Whole Theatre</a></p>
<p class="noindent"><span href="#/10_chapter031#map2" title="Link target outside of Sample">2. 14/15 June</span></p>
<p class="noindent"><span href="#/12_chapter033#map3" title="Link target outside of Sample">3. Allied Concentration Areas</span></p>
<p class="noindent"><span href="#/24_chapter051#map4" title="Link target outside of Sample">4. North of Charleroi</span></p>
<p class="noindent"><span href="#/27_chapter061#map5" title="Link target outside of Sample">5. 16 June</span></p>
<p class="noindent"><span href="#/30_chapter071#map6" title="Link target outside of Sample">6. The Quatre Bras Battlefield</span></p>
<p class="noindentt"><span class="bold">Figures</span></p>
<p class="noindent"><span href="#/32_chapter073#figure1" title="Link target outside of Sample">1. A French Battalion Assault Column</span></p>
<p class="noindent"><span href="#/61_chapter161#figure2" title="Link target outside of Sample">2. <em class="italic">Ordre Mixte</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_illustrations.vue?6425628c